import axios from 'axios';
import { AUTH_ROOT, HOME_ROOT } from 'config/api';

const dialogActions = {
  AGREE: 'DIALOG_AGREE',
  AGREE_SUCCESS: 'DIALOG_AGREE_SUCCESS',
  CLOSE: 'DIALOG_CLOSE',
  OPEN: 'DIALOG_OPEN',
  SEND_CODE: 'DIALOG_SEND_CODE',
  SEND_CODE_SUCCESS: 'DIALOG_SEND_CODE_SUCCESS',
  SIGN: 'DIALOG_SIGN',
  SIGN_SUCCESS: 'DIALOG_SIGN_SUCCESS',

  agree: (requestId, disclosureId) => ({
    payload: {
      endpoint: 'disclosures',
      id: requestId,
      request: () =>
        axios.post(`${HOME_ROOT}/${requestId}/disclosures/${disclosureId}/accept`, {
          agreed: true,
        }),
    },
    type: dialogActions.AGREE,
  }),
  close: () => ({
    type: dialogActions.CLOSE,
  }),
  open: (type, params = null) => ({
    payload: { params, type },
    type: dialogActions.OPEN,
  }),

  sendCode: () => ({
    payload: {
      request: (data) => () => axios.post(`${AUTH_ROOT}/actions/sendCode`, data),
    },
    type: dialogActions.SEND_CODE,
  }),

  sign: (requestId, agreementId, data) => ({
    payload: {
      endpoint: 'agreements',
      id: requestId,
      request: () =>
        axios.post(`${HOME_ROOT}/${requestId}/agreements/${agreementId}/submitESign`, data),
    },
    type: dialogActions.SIGN,
  }),
};

export default dialogActions;
